import * as React from 'react';
import styles from './list-view-column.scss';

export interface ListViewColumnProps {
  children?: React.ReactNode;
  displaySingleFlexibleColumn?: boolean;
}

export const ListViewColumn = ({ children, displaySingleFlexibleColumn }: ListViewColumnProps) => {

  return (
    <div 
      className={`${styles.listViewColumn} ${styles.flexible} ${displaySingleFlexibleColumn ? styles.listViewColumnAuto : ''}`}
      data-testid="list-view-column"
    >
      {children}
    </div>
  );
};
